// hooks/useMoveTo.js
import { useNavigate } from 'react-router-dom';

const useMoveTo = () => {
    const navigate = useNavigate();

    /**
     * moveTo: navigate to a URL, works in Android WebView and normal browser
     * @param {string} url - the URL or route to navigate
     * @param {object} options - optional, { replace: boolean, state: object }
     */
    const moveTo = (url, options = {}) => {
        const { replace = false, state = {} } = options;

        if (typeof window !== 'undefined' && /Android/i.test(navigator.userAgent)) {
            // Android WebView: force reload (state won't persist here)
            // window.location.href = url;
            navigate(url, { replace, state });
        } else {
            // Normal SPA navigation
            navigate(url, { replace, state });
        }
    };

    return moveTo;
};

export default useMoveTo;
